module.exports = __webpack_public_path__ + "static/img/pg3.945bbbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pg3.png
// module id = pjNM
// module chunks = 1